export const FLOWABLE_DESIGN_URL = process.env.REACT_APP_FLOWABLE_DESIGN_URL;
export const FLOWABLE_BASE_URL = process.env.REACT_APP_FLOWABLE_ENGAGE_URL;
